import styled from "@emotion/styled"
import { FlexContainer } from "../../../../../styled/flexbox.styled"

export const WaveSelectContainer = styled(FlexContainer)({
  width: "100%",
})
